// web/src/lib/config.ts — הגדרות ציבוריות של האפליקציה (D-245).
// ✅ הערכים כאן ציבוריים בכוונה: כל מה שהאפליקציה צריכה נשלח לדפדפן בכל מקרה.
// 🔑 המפתח "publishable" של Supabase נועד לדפדפן; האבטחה במסד (RLS) ובשרת (אסימון).
// ⛔ לעולם לא מפתח service_role / סיסמה / מפתח Woo כאן — כל מה שבקובץ הזה נחשף.
// 🔁 דריסה (פיתוח מקומי / סביבה אחרת): משתני VITE_* — ב-web/.env.local (חסום בגיט) או במשתני השירות ב-Railway.
// ⛔ אין web/.env בעץ (אינווריאנט 4): קובץ בשם .env מלמד לשים בו סודות.

const DEFAULTS = {
  apiUrl: "https://api.atida-s.com",   // ✅ 26.09 — DNS ב-SiteGround (CNAME + TXT אימות) · תעודה תקפה. הישנה: atida-api-production.up.railway.app
  supabaseUrl: "https://sqbsfnoauchzdjzmxutd.supabase.co",
  supabaseKey: "sb_publishable_fAX6rjBpGIBOGusFcSk-fA_ft7qv_fA",
} as const;

// 🔑 הגדרה ריקה אחרי הדריסה = שגיאה מיד בעלייה ⛔ ולא התנהגות שקטה מול לקוחה.
function pick(name: string, override: string | undefined, fallback: string): string {
  const v = (override ?? "").trim() || fallback;
  if (!v) throw new Error(`הגדרה חסרה: ${name} (web/src/lib/config.ts)`);
  return v.replace(/\/+$/, "");
}

export const config = {
  apiUrl: pick("VITE_API_URL", import.meta.env.VITE_API_URL, DEFAULTS.apiUrl),
  supabaseUrl: pick("VITE_SUPABASE_URL", import.meta.env.VITE_SUPABASE_URL, DEFAULTS.supabaseUrl),
  supabaseKey: pick("VITE_SUPABASE_KEY", import.meta.env.VITE_SUPABASE_KEY, DEFAULTS.supabaseKey),
} as const;
